import { NgModule } from '@angular/core';

import { SharedModule } from '../shared/shared.module';

import { NavigationRailComponent } from './navigation-rail.component';
import { PopupChangingRoleComponent } from './popup-changing-role/popup-changing-role.component';

@NgModule({
  exports: [NavigationRailComponent],
  imports: [SharedModule, NavigationRailComponent, PopupChangingRoleComponent],
})
export class NavigationRailModule {}
